import { NextRouter } from "next/router"
import { Suggestion, SuggestionGroups } from "../../api-clients/suggest-openapi"
import { pages, pdpQueryParams } from "../constants/constants"
import { suggestSections } from "../constants/suggest-constants"
import { redirectToPage } from "./router-utils"

const checkForExactMatch = (suggestionGroups: Array<SuggestionGroups>, router: NextRouter, searchTerm: string) => {
  // Guard clause if we don't have any actual suggestions provided by Fredhopper
  if (!suggestionGroups?.length) return false

  const productSuggestions = suggestionGroups.find(
    (group: SuggestionGroups) => group.indexName === suggestSections.PRODUCTS
  )?.suggestions
  const sparePartSuggestions = suggestionGroups.find(
    (group: SuggestionGroups) => group.indexName === suggestSections.SPARE_PARTS
  )?.suggestions
  const articleSuggestions = suggestionGroups.find(
    (group: SuggestionGroups) => group.indexName === suggestSections.ARTICLES
  )?.suggestions

  if (isExactArticleMatch(productSuggestions, articleSuggestions)) {
    /* If it is an exact article match but there are spare parts suggestions as well
    don't redirect to the PDP page */
    if (sparePartSuggestions.length > 0) return false

    const article = articleSuggestions[0]
    const productId = article.productid

    redirectToPage(router, pages.PRODUCT, productId, {
      [pdpQueryParams.ARTICLES]: article.articlenumber,
      [pdpQueryParams.SEARCH_TERM]: searchTerm,
    })

    return true
  }

  if (isExactProductMatch(productSuggestions, sparePartSuggestions, articleSuggestions)) {
    const product = productSuggestions[0]
    const productId = product.productid

    redirectToPage(router, pages.PRODUCT, productId)

    return true
  }

  if (isExactSparePartMatch(productSuggestions, sparePartSuggestions, articleSuggestions)) {
    const sparePart = sparePartSuggestions[0]
    const sparePartId = sparePart.secondId.replace("p_", "").toUpperCase()

    redirectToPage(router, pages.SPARE_PART, sparePartId)

    return true
  }

  return false
}

const isExactProductMatch = (
  productSuggestions: Array<Suggestion>,
  sparePartSuggestions: Array<Suggestion>,
  articleSuggestions: Array<Suggestion>
) => {
  if (sparePartSuggestions.length === 0 && articleSuggestions.length <= 1 && productSuggestions.length === 1) {
    return true
  }

  return false
}

const isExactArticleMatch = (productSuggestions: Array<Suggestion>, articleSuggestions: Array<Suggestion>) => {
  // Guard clause if we don't have any actual suggestions provided by Fredhopper
  if (!articleSuggestions?.length || !productSuggestions?.length) return false

  if (articleSuggestions.length === 1 && productSuggestions.length === 1) {
    return true
  }

  return false
}

const isExactSparePartMatch = (
  productSuggestions: Array<Suggestion>,
  sparePartSuggestions: Array<Suggestion>,
  articleSuggestions: Array<Suggestion>
) => {
  if (productSuggestions.length === 0 && articleSuggestions.length === 0 && sparePartSuggestions.length === 1) {
    return true
  }

  return false
}

const isExactMatch = (
  productSuggestions: Array<Suggestion>,
  sparePartSuggestions: Array<Suggestion>,
  articleSuggestions: Array<Suggestion>
) => {
  return (
    isExactProductMatch(productSuggestions, sparePartSuggestions, articleSuggestions) ||
    isExactArticleMatch(productSuggestions, articleSuggestions) ||
    isExactSparePartMatch(productSuggestions, sparePartSuggestions, articleSuggestions)
  )
}

export { checkForExactMatch, isExactArticleMatch, isExactMatch, isExactProductMatch, isExactSparePartMatch }
